import * as React from "react";
import {Modal} from "../../Modal/Modal";
import {Translations} from "../../../translations/Translations";
import {DealerNewsEntity} from "../../../services/DealerNews";

type DealerNewsEditModalProps = {
    deleteFormVisible: boolean,
    onCloseRequest: () => void,
    onDelete: (news: DealerNewsEntity) => void,
    news: DealerNewsEntity,
    trn: Translations,
}

export const DealerNewsDeleteModal = ({onDelete, onCloseRequest, trn, news, deleteFormVisible}: DealerNewsEditModalProps) => {

    return <Modal className={"modal-alert dealer-news"} visible={deleteFormVisible}
                  onCloseRequest={() => onCloseRequest()}
                  title={trn.confirmDelete}>

        {news &&
            <p>{trn.deleteQuestion.replace('%title%', news.title)}</p>
        }

        <a style={{margin: '10px 0'}} className={"button"} onClick={() => onDelete(news)}>{trn.confirm}</a>
    </Modal>

}